(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3986],{

/***/ 67127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feed",
      function () {
        return __webpack_require__(77637);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_Feed_FeedComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48043);



var NewFeedPage = function() {
    // const [scrollY, setScrollY] = useState(0)
    // useEffect(() => {
    //   window.addEventListener('scroll', () => {
    //     setScrollY(window.pageYOffset)
    //   })
    // }, [scrollY])
    // const dispatch = useAppDispatch()
    // const productRecommendations = useSelector((state: any) => state?.feedData?.productRecommendations)
    // const fetchProduct = (product_id = null, type = null) => {
    //   let update_product = productRecommendations?.product?.getAllProducts?.data?.map((prd) => {
    //     if (prd?.id === product_id) {
    //       return {
    //         ...prd,
    //         likes: type === 'like' ? { id: 3.3333 } : null,
    //         like_count: type === 'like' ? (parseInt(prd.like_count) || 0) + 1 : (parseInt(prd.like_count) || 1) - 1,
    //       }
    //     } else {
    //       return prd
    //     }
    //   })
    //   if (update_product) {
    //     dispatch(fetchProductRecommendation(update_product))
    //   }
    // }
    // const fetchUpdatedProduct = (product_id, type) => {
    //   fetchProduct(product_id, type)
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Feed_FeedComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            postData: {}
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NewFeedPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8043,9774,2888,179], function() { return __webpack_exec__(67127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);